// Możesz przenieść tutaj stałą DEPENDENCY_TYPES
export const DEPENDENCY_TYPES = [
  { value: 'waiting_for', label: 'Oczekuje na' },
  { value: 'blocks', label: 'Blokuje' },
  { value: 'related', label: 'Powiązane z' }
]

// Możesz tu dodać inne stałe związane z zadaniami
